export const ShipmentMethod = {
    CARRIER: 1,
    PICKUP: 2,
    DROPOFF: 3,
};
//# sourceMappingURL=ShipmentMethod.js.map